import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import {
  MODAL_SECTION,
  SUCCEEDED
} from 'utils/constants'
import {
  isAuth,
  showCoordParams
} from 'utils/helpers'
import { AnimatePresence } from 'framer-motion'
import { Content } from 'components/Content/BlogModal/Content'
import { ContentForBlogPreview } from 'components/Content/BlogModal/ContentForBlogPreview'
import { AskToSignUpModal } from 'components/Content/AskToSignUpModal'
import {
  authSelectors,
  handleOpenModal,
  setOpenPopupBlogs,
  setPosts,
  setChosenBlogIndex,
  setComments,
  setBlogParent,
  setBlogRepostData,
  setHideNotification,
  setHideChat,
  setChatSectionPage,
  setOpenPopupEvents,
  setNotificationSectionPage,
  setUserSectionPage,
  usersSelectors
} from 'store'

export const BlogModal = () => {
  const dispatch = useDispatch()
  const {
    activeProfile,
    blogRepostData,
    blogRepostParent,
    adminNotifications,
    blogParent,
    chosenBlogIndex,
    closeAllDrawers,
    comments,
    commentsOption,
    getCommentsStatus,
    getPostsStatus,
    getUserProfileStatus,
    getUserStatus,
    hideNotification,
    postCommentsStatus,
    putCommentsStatus,
    posts,
    profileItem,
    openPopupBlogs,
    subscribeToProfileStatus,
    chosenNotifBlog,
    postsOption,
    newPostsOption,
    chatSectionPage,
    deleteCommentsStatus
  } = useSelector(usersSelectors)
  const { signInStatus } = useSelector(authSelectors)

  const [askToSignUp, setAskToSignUp] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [disableOverlayClick, setDisableOverlayClick] = useState(false)
  const [outAnim, setOutAnim] = useState(false)

  const isLoggedIn = signInStatus === SUCCEEDED || isAuth()

  const animateMarkerFilter = (isOpen) => dispatch(handleOpenModal({
    isOpen,
    section: MODAL_SECTION.RightSection
  }))

  const handleAuthOverlayClick = () => {
    document.querySelector('#custom-popup-overlay')?.click()
    document.querySelector('#custom-popup-overlay-event')?.click()
    dispatch(setChatSectionPage('clear'))
    dispatch(setUserSectionPage('clear'))
    dispatch(setOpenPopupBlogs(false))
    dispatch(setOpenPopupEvents(false))
    dispatch(setNotificationSectionPage('clear'))
    dispatch(setBlogRepostData([]))
    dispatch(handleOpenModal({
      isOpen: false,
      section: MODAL_SECTION.RightSection
    }))
  }

  const closeDrawer = () => {
    setDisableOverlayClick(true)

    if (postsOption.type !== 'marker') {
      sessionStorage.removeItem('postId')
    }

    dispatch(setHideNotification(false))
    dispatch(setHideChat(false))

    if (
      postsOption.type !== 'marker'
      && !chatSectionPage.length
    ) {
      showCoordParams(setSearchParams)
    }

    dispatch(setUserSectionPage('clear'))
    dispatch(setOpenPopupBlogs(false))
    dispatch(setBlogRepostData([]))
    setDisableOverlayClick(false)
    setTimeout(() => {
      dispatch(setPosts([]))
      dispatch(setComments([]))
      dispatch(setBlogParent([]))
    }, 800)
  }

  useEffect(() => {
    if (
      isLoggedIn
      && getUserProfileStatus === SUCCEEDED
      && sessionStorage.getItem('postId')
    ) {
      setOutAnim(false)
      setAskToSignUp(false)
    }
  }, [isLoggedIn, getUserProfileStatus])

  useEffect(() => {
    if (closeAllDrawers) {
      closeDrawer()
    }
  }, [closeAllDrawers])

  useEffect(() => {
    if (openPopupBlogs) {
      dispatch(setChosenBlogIndex(null))
    }
  }, [openPopupBlogs])

  return (
    <>
      <AskToSignUpModal
        dynamicOpenModal={!isLoggedIn && askToSignUp && openPopupBlogs}
        posts={posts}
        type="blogs"
        setAskToSignUp={setAskToSignUp}
        setOutAnim={setOutAnim}
        outAnim={outAnim}
      />

      {
        !isAuth()
        && openPopupBlogs
        && (
          <Box
            id="blog-modal-overlay"
            zIndex={1399}
            background="transparent"
            position="fixed"
            width="100%"
            height="100%"
            top={0}
            onClick={() => {
              if (!disableOverlayClick) {
                setOutAnim(true)
              }
            }}
          />
        )
      }

      {
        (
          openPopupBlogs
          || blogRepostData?.length > 0
        )
        && isAuth()
        && (
          <>
            <Box
              id="blog-modal-overlay"
              zIndex={1399}
              background="transparent"
              position="fixed"
              width="100%"
              height="50px"
              top={0}
              onClick={() => {
                if (!disableOverlayClick) {
                  handleAuthOverlayClick()
                }
              }}
            />

            <Box
              zIndex={1399}
              background="transparent"
              position="fixed"
              width="100%"
              height="50px"
              bottom={0}
              onClick={() => {
                if (!disableOverlayClick) {
                  handleAuthOverlayClick()
                }
              }}
            />
          </>
        )
      }

      <AnimatePresence>
        {
          openPopupBlogs
          && (
            <Content
              activeProfile={activeProfile}
              adminNotifications={adminNotifications}
              animateMarkerFilter={animateMarkerFilter}
              askToSignUp={askToSignUp}
              blogParent={blogParent}
              chosenBlogIndex={chosenBlogIndex}
              chosenNotifBlog={chosenNotifBlog}
              closeDrawer={closeDrawer}
              comments={comments}
              commentsOption={commentsOption}
              getCommentsStatus={getCommentsStatus}
              getPostsStatus={getPostsStatus}
              hideNotification={hideNotification}
              isLoggedIn={isLoggedIn}
              postCommentsStatus={postCommentsStatus}
              posts={posts}
              postsOption={postsOption}
              profileItem={profileItem}
              putCommentsStatus={putCommentsStatus}
              setAskToSignUp={setAskToSignUp}
              subscribeToProfileStatus={subscribeToProfileStatus}
              newPostsOption={newPostsOption}
              getUserStatus={getUserStatus}
              blogRepostData={blogRepostData}
              deleteCommentsStatus={deleteCommentsStatus}
            />
          )
        }
      </AnimatePresence>

      <AnimatePresence>
        {
          blogRepostData?.length > 0
          && (
            blogRepostData.map((data) => (
              <ContentForBlogPreview
                key={`blog-repost-panel-${data?.id}`}
                activeProfile={activeProfile}
                animateMarkerFilter={animateMarkerFilter}
                adminNotifications={adminNotifications}
                blogRepostData={blogRepostData}
                blogRepostParent={blogRepostParent}
                chosenBlogIndex={chosenBlogIndex}
                chosenNotifBlog={chosenNotifBlog}
                closeDrawer={closeDrawer}
                comments={comments}
                commentsOption={commentsOption}
                data={data}
                getCommentsStatus={getCommentsStatus}
                getPostsStatus={getPostsStatus}
                postCommentsStatus={postCommentsStatus}
                postsOption={postsOption}
                profileItem={profileItem}
                putCommentsStatus={putCommentsStatus}
                subscribeToProfileStatus={subscribeToProfileStatus}
                newPostsOption={newPostsOption}
                deleteCommentsStatus={deleteCommentsStatus}
              />
            ))
          )
        }
      </AnimatePresence>
    </>
  )
}
